// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"732d10d0","513":"ac5a4425","703":"9c8e6c15","787":"152affe4"}[chunkId] + ".chunk.js";
};